import { ModuleFE_FindingView } from './ModuleFE_FindingView.js';
export const ModulePackFE_FindingViewDB = [ModuleFE_FindingView];
//# sourceMappingURL=module-pack.js.map